/** ログイン不要の完了報告(/r/:token)。トークンだけが鍵なので、出す情報は最小にする。 */
import { useMutation, useQuery } from "@tanstack/react-query";
import { Alert, Button, Card, Descriptions, Input, Result, Space, Spin, Typography } from "antd";
import { useState } from "react";
import { useParams } from "react-router-dom";

import { useApi } from "../lib/useApi";

export function PublicReport() {
  const api = useApi();
  const { token = "" } = useParams();
  const [note, setNote] = useState("");
  const q = useQuery({
    queryKey: ["public-report", token],
    queryFn: () => api.publicReport(token),
    retry: false,
  });
  const submit = useMutation({
    mutationFn: () => api.submitPublicReport(token, note),
  });

  const frame = (children: React.ReactNode) => (
    <div style={{ maxWidth: 640, margin: "48px auto", padding: "0 16px" }}>
      <Typography.Title level={4}>作業の完了報告</Typography.Title>
      {children}
    </div>
  );

  if (q.isLoading) return frame(<Spin />);

  if (q.isError || !q.data)
    return frame(
      <Result
        status="404"
        title="この URL は使えない"
        subTitle="報告済み、または期限切れの可能性がある。依頼元に連絡してください。"
      />,
    );

  if (submit.isSuccess || q.data.reported)
    return frame(
      <Result
        status="success"
        title="報告を受け付けた"
        subTitle="この URL はもう使えません。ありがとうございました。"
      />,
    );

  return frame(
    <Card size="small">
      <Descriptions column={1} size="small" style={{ marginBottom: 16 }}>
        <Descriptions.Item label="依頼元">{q.data.partner_name}</Descriptions.Item>
        <Descriptions.Item label="対象者">{q.data.employee_name}</Descriptions.Item>
        <Descriptions.Item label="件名">{q.data.subject}</Descriptions.Item>
        <Descriptions.Item label="依頼の向き">{q.data.action_label}</Descriptions.Item>
      </Descriptions>
      {submit.isError && (
        <Alert
          type="error"
          showIcon
          style={{ marginBottom: 16 }}
          message="送信できなかった"
          description="時間をおいて試すか、依頼元に連絡してください。"
        />
      )}
      <Space direction="vertical" style={{ width: "100%" }}>
        <Input.TextArea
          rows={5}
          placeholder="発行したアカウント名や、対応できなかった項目などを書いてください(任意)"
          value={note}
          onChange={(e) => setNote(e.target.value)}
          maxLength={2000}
        />
        <Button type="primary" loading={submit.isPending} onClick={() => submit.mutate()}>
          完了を報告する
        </Button>
        <Typography.Text type="secondary" style={{ fontSize: 12 }}>
          ログインは要りません。報告すると、この URL は使えなくなります。
        </Typography.Text>
      </Space>
    </Card>,
  );
}
